// extracted by mini-css-extract-plugin
export default {"item":"Item_item__+Ah8B","anchor":"Item_anchor__DbfEl","title":"Item_title__zfJt-"};